import { Ban, TriangleAlertIcon } from 'lucide-react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@tinct/web-components';

export type UnpublishPageModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Display name of the variant (company name); falls back to generic copy. */
  pageName?: string | null;
  isPending?: boolean;
  onConfirm: () => void;
};

/**
 * Confirmation before taking a single live variant offline — campaign-level
 * unpublish already confirms; per-variant must not fire on a stray click.
 */
export function UnpublishPageModal({
  open,
  onOpenChange,
  pageName,
  isPending,
  onConfirm,
}: UnpublishPageModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            Unpublish {pageName ? `the ${pageName} variant` : 'this variant'}
          </DialogTitle>
        </DialogHeader>
        <div className="flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3">
          <TriangleAlertIcon className="mt-0.5 size-4 shrink-0 text-amber-600" />
          <div className="flex flex-1 flex-col gap-1 text-sm text-amber-700">
            <span>
              Visitors from this account will see the original page instead of
              their personalized variant until you publish it again.
            </span>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm} isLoading={isPending}>
            <Ban className="size-4" />
            Unpublish
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
